module.exports = "/images/icon-ppt.svg?6b7f14df7ed466010d7f43c3f31bda6d";